import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    if (!document.body.classList.contains("nd-hero-transparent-page")) return
    this.scrollHandler = this.onScroll.bind(this)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
    this.onScroll()
  }

  disconnect() {
    if (this.scrollHandler) window.removeEventListener("scroll", this.scrollHandler)
  }

  onScroll() {
    this.element.classList.toggle("nd-navbar--scrolled", window.scrollY > 60)
  }

  toggleMenu() {
    this.menuTarget.classList.toggle("hidden")
  }
}
